import React from 'react'
import { useSelector } from 'react-redux';

export default function RallySquarePrivacyPolicy () {
  const webProperties = useSelector(state => state.landingReducer.webProperties)

      return (
          <>
              <nav className="navbar sticky-top navbar-expand-lg navbar-light" style={{backgroundColor: 'white'}}>
                  <button style={{background: 'white'}} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01"
                      aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
                      <span className="navbar-toggler-icon"></span>
                  </button>
                  <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
                      {/* eslint-disable-next-line */}
                      <a className="navbar-brand">
                          {/* <img src="images/common/agile2.png" width="170" alt="" /></Link> */}
                          <img className="agile-supportlogo" src="images/common/RallySquare.jpeg" width="110" alt="" />
  
                      </a>
                  </div>
              </nav>
              <div className="container ppc">
                <h1>Privacy Policy</h1>
                <h5><em>Last updated: May 5, 2025</em></h5>

                <p style={{fontSize: '13px'}}>
                    Welcome to <strong>RallySquare</strong>! Your privacy is important to us.
                    This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our services.
                    By using RallySquare, you agree to the terms outlined in this Privacy Policy.
                </p>
                <br/>

                <h2>1. Information We Collect</h2>
                <p style={{fontSize: '13px'}}>We collect the following types of information:</p>

                <h3>a. Personal Information</h3>
                <ul>
                    <li>Name, username, and email address</li>
                    <li>Contact details (if applicable)</li>
                </ul>

                <h3>b. Chat and Communication Data</h3>
                <ul>
                    <li>Messages exchanged in 1-on-1 chats, group chats, and task chats</li>
                    <li>Shared files, images, or media</li>
                    <li>Metadata such as timestamps</li>
                </ul>

                <h3>c. Usage and Device Information</h3>
                <ul>
                    <li>IP address, device type, and operating system</li>
                    <li>App usage data (e.g., feature usage, error logs)</li>
                </ul>

                <h3>d. User-Generated Reports</h3>
                <ul>
                    <li>Details submitted through the "Report" feature</li>
                    <li>Information about blocked users, including provided reasons</li>
                </ul>

                <h2>2. How We Use Your Information</h2>
                <p style={{fontSize: '13px'}}>We use your information to:</p>
                <ul>
                    <li>Deliver and enhance chat and task management features</li>
                    <li>Manage account access and authentication</li>
                    <li>Monitor and prevent abuse or violations</li>
                    <li>Respond to reports and maintain community standards</li>
                    <li>Analyze usage to improve our services</li>
                    <li>Provide technical and customer support</li>
                </ul>

                <h2>3. How We Share Your Information</h2>
                <p style={{fontSize: '13px'}}>We do not sell or rent your personal information. However, we may share data in the following scenarios:</p>
                <ul>
                    <li><strong>Service Providers:</strong> Trusted third parties who help operate our services (e.g., hosting, analytics, customer support).</li>
                    <li><strong>Legal Authorities:</strong> When required by law or to protect the rights, safety, or property of RallySquare, its users, or the public.</li>
                    <li><strong>Other Users:</strong> Members of your chats may view your profile name, photo, and shared content.</li>
                </ul>

                <h2>4. Data Security</h2>
                <p style={{fontSize: '13px'}}>We implement appropriate security measures to protect your data. However, no method of transmission or storage is 100% secure.</p>
                <br/>

                <h2>5. Data Retention</h2>
                <p style={{fontSize: '13px'}}>We retain your data only for as long as necessary to:</p>
                <ul>
                    <li>Deliver our services</li>
                    <li>Comply with legal obligations</li>
                    <li>Resolve disputes and enforce our terms</li>
                </ul>
                <p style={{fontSize: '13px'}}>Messages may be stored on our servers to support synchronization across devices and provide a consistent user experience.</p>
                <br/>

                <h2>6. Your Rights and Choices</h2>
                <p style={{fontSize: '13px'}}>Depending on your location, you may have the right to:</p>
                <ul>
                    <li>Access, correct, or delete your personal data</li>
                    <li>Restrict or object to certain data processing</li>
                    <li>Withdraw consent where applicable</li>
                </ul>
                <p style={{fontSize: '13px'}}>To exercise your rights, please contact us at <strong>support@wetasker.com</strong>.</p>
                <br/>
                <h2>7. Third-Party Services</h2>
                <p style={{fontSize: '13px'}}>
                    RallySquare may integrate with third-party platforms (e.g., file storage, login providers). These services have their own privacy policies, which we encourage you to review.
                </p>
                <br/>

                <h2>8. Children's Privacy</h2>
                <p style={{fontSize: '13px'}}>RallySquare is not intended for children under the age of 13 (or the applicable age in your region). We do not knowingly collect data from children.</p>
                <br/>

                <h2>9. Third-Party Links</h2>
                <p style={{fontSize: '13px'}}>Our app may contain links to third-party websites or services. We are not responsible for their privacy practices or content.</p>
                <br/>

                <h2>10. Changes to This Privacy Policy</h2>
                <p style={{fontSize: '13px'}}>
                    We may update this Privacy Policy from time to time. Changes will be posted here with an updated "Last updated" date. Continued use of the app indicates your acceptance of any changes.
                </p>
                <br/>

                <h2>11. Contact Us</h2>
                <p style={{fontSize: '13px'}}>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
                <p style={{fontSize: '13px'}}><strong>Email:</strong> support@wetasker.com</p>
                </div>

              <footer id="footer-releasenote" style={{ backgroundColor: webProperties?.PRIMARY_COLOR !== "#47974b" ? webProperties?.PRIMARY_COLOR : '#47974b' }}>
                  <div style={{ color: 'white' }}>
                      RallySquare © Copyright {new Date().getFullYear()}. All Rights Reserved.
                  </div>
              </footer>
          </>
      )
}

